export default function calculateDatesRange({ rangeStart, rangeEnd, interval = 14 }) {
    const startDate = typeof rangeStart === 'string' || typeof rangeStart === 'number'
        ? new Date(rangeStart)
        : rangeStart;
    const endDate = typeof rangeEnd === 'string' || typeof rangeEnd === 'number' ? new Date(rangeEnd) : rangeEnd;
    const dates = [];
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
        dates.push(currentDate.getTime());
        currentDate.setDate(currentDate.getDate() + interval);
    }
    return dates;
}
